
import React, { useEffect, useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { IncidentLinkDialog } from './IncidentLinkDialog';
import { supabase } from '@/integrations/supabase/client';

interface NoFormsProps {
  isAdmin: boolean;
  teamId?: string;
}

export const NoForms = ({ isAdmin, teamId }: NoFormsProps) => {
  const { t } = useLanguage();
  const [hasConfiguredLink, setHasConfiguredLink] = useState(false);
  
  useEffect(() => {
    if (teamId) {
      checkIfLinkConfigured();
    }
  }, [teamId]);
  
  const checkIfLinkConfigured = async () => {
    if (!teamId) return;
    
    try {
      // Check if there's a link in Supabase
      const { data } = await supabase
        .from('team_incident_links' as any)
        .select('link_url')
        .eq('team_id', teamId)
        .maybeSingle();
        
      if (data && (data as any).link_url) {
        setHasConfiguredLink(true);
        return;
      }
      
      // Fallback to localStorage check
      const savedLink = localStorage.getItem(`incident-report-link-${teamId}`);
      setHasConfiguredLink(!!savedLink);
    } catch (error) {
      console.error('Error checking for configured link:', error);
      
      // Fallback to localStorage check on error
      const savedLink = localStorage.getItem(`incident-report-link-${teamId}`);
      setHasConfiguredLink(!!savedLink);
    }
  };
  
  return (
    <div className="flex flex-col items-center justify-center p-6 text-center">
      <p className="text-lg text-gray-500 mb-2">
        {hasConfiguredLink 
          ? t("loadingForms") || "Loading incident report forms..." 
          : t("noForms") || "No incident reports configured"
        }
      </p>
      
      {!hasConfiguredLink && (
        <p className="text-gray-400 mb-4">
          {isAdmin 
            ? t("configureIncidentReports") || "Configure incident reports submission link using the button above"
            : t("noReportsAvailable") || "No incident report forms are currently available"
          }
        </p>
      )}
      
      {isAdmin && teamId && (
        <div className="mt-4">
          <IncidentLinkDialog teamId={teamId} />
        </div>
      )}
      
      {!isAdmin && teamId && !hasConfiguredLink && (
        <p className="text-sm text-gray-400 mt-4">
          {t("contactAdmin") || "Please contact an administrator to configure incident report forms"}
        </p>
      )}
    </div>
  );
};
